var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.817 1.524a.86.86 0 0 1 .48.48l2.286 5.752 6.178.397a.857.857 0 0 1 .492 1.516l-4.765 3.952 1.532 5.998a.857.857 0 0 1-1.289.936l-5.231-3.31-5.231 3.31a.858.858 0 0 1-1.29-.936l1.532-5.999-4.764-3.951a.857.857 0 0 1 .492-1.516l6.178-.397 2.287-5.752a.857.857 0 0 1 1.112-.48h.001Zm1.693 7.71L12.5 4.176l-2.01 5.057-5.43.349 4.188 3.475L7.9 18.328 12.5 15.42l4.598 2.91-1.346-5.272 4.188-3.475-5.43-.348Z",
    fill: "#FF5160"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.c58066cf2bd0e0ed89e1e4e2fb8c6265.svg";
export { ForwardRef as ReactComponent };